module.exports = __webpack_public_path__ + "Mark.99ae1963.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/mocks/Mark.png
// module id = 2388
// module chunks = 0